/**
 * 공공데이터 메인 — Editorial Hero (N3).
 * 풀스크린/캐러셀 없이 단일 칼럼 좌측 정렬. 얇은 그리드 배경 위 에디토리얼 타이포.
 */
export default function Hero() {
  return (
    <section className="pd-section pd-hero">
      <div className="pd-container">
        <span className="pd-eyebrow pd-eyebrow--hero">PUBLIC DATA PLATFORM</span>

        <h1 className="pd-hero__title">
          공공데이터 개방을 넘어,
          <br />
          <span className="pd-grad">공공혁신의 플랫폼</span>을 만듭니다
        </h1>

        <p className="pd-hero__sub">
          국가중점데이터 개방과 빅데이터 기반 솔루션을 통해 <b>공공데이터의 가치</b>를 극대화합니다.
        </p>

        <div className="pd-hero__highlights">
          <span className="pd-hero__hl">국가중점데이터 개방</span>
          <span className="pd-hero__hl">빅데이터 기반 솔루션</span>
          <span className="pd-hero__hl">공공혁신 플랫폼</span>
        </div>
      </div>
    </section>
  );
}
